import React, { useState }  from "react";
import "./Header.scss";
import TelephoneSearch from "./TelephoneSearch/TelephoneSearch";
import ActionButtons from "./ActionButtons/ActionButtons";
import LanguageToggle from "./LanguageToggle/LanguageToggle";

const isDev = process.env.NODE_ENV === "development";

const Header = () => {
  const [dataFromChild, setDataFromChild] = useState('');
  const [message, setMessage] = useState('');
  const [toastClass, settoastClass] = useState('');

  const handleData = (data) => {
    setDataFromChild(data);
    if(dataFromChild === 200) {
      setMessage("正常完了：情報連携が完了しました。");
      settoastClass("alert-success");
    } else {
      setMessage(" エラー　　 ：情報連携に失敗しました。再度ボタンをクリックして下さい。");
      settoastClass("alert-failure");
    }
  };
  return (
    <>
      <div className={toastClass}>
        <p>{message}</p>
      </div>
      <div className="header">
        <TelephoneSearch />
        <span className="second-row">
          <ActionButtons onSalesForceResponse={handleData}/>
          {isDev && <LanguageToggle />}
        </span>
    </div>
    </>

  );
};

export default Header;
